var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-dates-row"},[_c('div',[_vm._t("startDate"),(_vm.startDateError)?_c('span',{staticClass:"app-input-error"},[_vm._v(" "+_vm._s(_vm.startDateError[0])+" ")]):_vm._e()],2),_c('div',[_vm._t("endDate"),(_vm.endDateError)?_c('span',{staticClass:"app-input-error"},[_vm._v(" "+_vm._s(_vm.endDateError[0])+" ")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }